import { Component } from '@angular/core';
import { SharedComponents } from '../../components/shared.module';
import { Tabs } from "../../core/models/tab-field";
import { BaseLayoutComponent } from '../base-layout.component';
import { TestExecutionComponent } from './test-execution/test-execution.component';
import { TestPlanningComponent } from './test-planning/test-planning.component';
import { TestScheduleComponent } from './test-schedule/test-schedule.component';
import { CICDExecutionsComponent } from './cicd-executions/cicd-executions.component';


@Component({
  selector: 'app-execution-management',
  standalone: true,
  imports: [...SharedComponents],
  templateUrl: './execution-management.component.html',
  styleUrl: './execution-management.component.scss'
})
export class ExecutionManagementComponent extends BaseLayoutComponent {
  tabs: Tabs[] = [
    {
      label: "Test Planning",
      component: TestPlanningComponent,
      view: '',
      disabled: false,
    },
    {
      label: "Test Execution",
      component: TestExecutionComponent,
      view: '',
      disabled: false,
    },
    {
      label: "CI/CD Based Execution ",
      component: CICDExecutionsComponent,
      view: '',
      disabled: false,
    },
    {
      label: "Test Schedule",
      component: TestScheduleComponent,
      view: '',
      disabled: true,
    }
  ];
}
